import * as types from "./types";

export const closePanel = () => ({
  type: types.CLOSE_PANEL
});

export const openBookPanel = (isbn, tab, title) => ({
  type: types.OPEN_PANEL,
  data: { isbn, type: "book", tab, title }
});

export const changePanelTab = tab => ({
  type: types.CHANGE_PANEL_TAB,
  tab
});

export const openSearchPanel = (isbn, title) => ({
  type: types.OPEN_PANEL,
  data: { isbn, type: "search", title }
});

export const openMobileLibSearchPanel = () => ({
  type: types.OPEN_PANEL,
  data: { type: "mobile-search", title: "results" }
});

export const updateBookGridView = (category, title) => ({
  type: types.UPDATE_BOOK_GRID_VIEW,
  data: { category, title }
});

export const openSimpleBookPanel = (isbn, title) => ({
  type: types.OPEN_PANEL,
  data: { isbn, type: "simplebook", tab: "details", title }
});

export const openSimpleResourcesPanel = (isbn, title) => ({
  type: types.OPEN_PANEL,
  data: { isbn, type: "simplebook", tab: "resources", title }
});

export const toggleMobileHeaderMenu = () => ({
  type: types.TOGGLE_MOBILE_HEADER_MENU
});

export const closeMobileHeaderMenu = () => ({
  type: types.CLOSE_MOBILE_HEADER_MENU
});

export const openCoursewarePanel = (isbn, title) => ({
  type: types.OPEN_PANEL,
  data: { isbn, type: "courseware", title }
});
